import { Validator } from '../../types/Validator';

const errorCode = 'INVALID_MOBILE_PHONE';
const regexp = RegExp(/^\+573[0-9]{9}$/);

const validateMobilePhone: Validator = value => {
  const isEmpty = String(value).trim() === '';
  const isValid = regexp.test(String(value).replace(/[\s-]/g, ''));
  return value === undefined || isEmpty || isValid ? undefined : { errorCode };
};

export { errorCode, validateMobilePhone };
